import { useEffect, useMemo, useState } from 'react';
import moment from 'moment';
import { FaAngleDown } from "react-icons/fa6";
import { BsCalendarEvent } from "react-icons/bs";
import DateRangePicker from 'react-bootstrap-daterangepicker';
import 'bootstrap-daterangepicker/daterangepicker.css';

const DateRangeSelector = ({ updateRange, recentMonth, restrictMaxDate = false }) => {
  const startdateupdate = moment().subtract(29, 'days').format("DD-MM-YYYY");
  const startOfMonth = moment().startOf('month').format("DD-MM-YYYY");
  const enddateupdate = moment().format("DD-MM-YYYY");
  const maxDate = restrictMaxDate ? null : moment().endOf('month').format("DD-MM-YYYY");

  const [startDate, setStartDate] = useState(recentMonth ? startOfMonth : startdateupdate);
  const [endDate, setEndDate] = useState(enddateupdate);

  const handleOnApply = (event, picker) => {
    const end = moment(picker.endDate).format("DD-MM-YYYY");
    const start = moment(picker.startDate).format("DD-MM-YYYY");
    setEndDate(end);
    setStartDate(start);
    updateRange({ startDate: start, endDate: end });
  }

  const dateSettings = useMemo(() => {
       const settings = {
        locale: { format: 'DD-MM-YYYY', separator: '-' },
        startDate, endDate, showDropdowns: true,
        // ranges: {
        //   'Last 7 Days': [
        //     moment().subtract(6, 'days').format("DD-MM-YYYY"),
        //     moment().format("DD-MM-YYYY"),
        //   ],
        //   'Last 30 Days': [
        //     moment().subtract(29, 'days').format("DD-MM-YYYY"),
        //     moment().format("DD-MM-YYYY"),
        //   ],
        //   'Last 90 Days': [
        //     moment().subtract(89, 'days').format("DD-MM-YYYY"),
        //     moment().format("DD-MM-YYYY"),
        //   ],
        //   'Last 1 Year': [
        //     moment().subtract(1, 'year').add(1, 'day').format("DD-MM-YYYY"),
        //     moment().format("DD-MM-YYYY"),
        //   ],
        // }
      }
      if(!restrictMaxDate) settings["maxDate"] = maxDate;
      return settings;
  }, [startDate, endDate, maxDate])

  useEffect(() => {
    if(recentMonth) updateRange({ startDate: startOfMonth, endDate: enddateupdate });
  }, [])

  return (
    <div className='date-range-picker mx-1 mb-1'>
      <DateRangePicker onApply={handleOnApply} startDate={startDate} endDate={endDate} initialSettings={dateSettings} onCallback={() => { }}>
        <div className='d-flex align-items-center justify-content-between'>
        <span><BsCalendarEvent size={16} /></span>
        <span>{`${startDate} - ${endDate}`}</span>
        <span><FaAngleDown size={16} /></span>
        </div>
      </DateRangePicker>
    </div>
  );
};

export default DateRangeSelector;